import React from "react";
import { RouteObject } from "react-router-dom";

import { OffersRoute } from "@src/features/offers/Offers.route";
import { ExperiencesRoute } from "@src/features/personalizations/pages/personalizationOverview/Experiences.route";
import { SiteContentRoute } from "@src/features/siteContent/SiteContent.route";

import { EXPERIENCE_ROUTES } from "../../routes";

export const ExperienceRoutes: RouteObject[] = [
  {
    path: EXPERIENCE_ROUTES.Experiences,
    element: <ExperiencesRoute />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Offers,
    element: <OffersRoute />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_SiteContent,
    element: <SiteContentRoute />,
  },
];
